<template>
  <div>
    <top-navbar></top-navbar>

    <div class="mb-5 background_color">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Employee
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        Training
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        <router-link class="decoration" to="/training/index">Trainers</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
        {{ trainer.tt_trainer_name || 'View Trainer' }}
      </h6>

      <div class="container-fluid">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-2">
          <button class="btn btn-sm btn-outline-primary bdr-rad" @click="goUpdate">Update</button>
        </div>

        <div class="card bdr-rad2 shadow p-2" v-if="isLoading">
          <div class="card-body">
            <div class="d-flex justify-content-center">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="card bdr-rad2 shadow p-2">
          <div class="card-body">
            <table class="table table-sm table-borderless" style="font-size: small">
              <tbody>
                <tr>
                  <td><b>Trainer Name</b></td>
                  <td>{{ trainer.tt_trainer_name }}</td>
                </tr>
                <tr>
                  <td><b>Designation</b></td>
                  <td>{{ trainer.designation }}</td>
                </tr>
                <tr>
                  <td><b>Contact No</b></td>
                  <td>{{ trainer.contact_no }}</td>
                </tr>
                <tr>
                  <td><b>Email</b></td>
                  <td>{{ trainer.email }}</td>
                </tr>
                <tr>
                  <td><b>Department</b></td>
                  <td>{{ trainer.department }}</td>
                </tr>
                <tr>
                  <td><b>Remarks</b></td>
                  <td>{{ trainer.other_qualififcation_remarks }}</td>
                </tr>
                <tr>
                  <td><b>Status</b></td>
                  <td>{{ trainer.tt_status }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from 'axios';
import authService from '@/auth.service';
import TopNavbar from './../../layout/TopNavbar.vue';
import ContentFooter from './../../layout/ContentFooter.vue';

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      trainer: {},
      isLoading: true,
    };
  },
  mounted() {
    this.loadTrainer();
  },
  methods: {
    goUpdate() {
      this.$router.push('/training/update?id=' + this.$route.query.id);
    },
    async loadTrainer() {
      try {
        const { data } = await axios.get('/training/view?id=' + this.$route.query.id, {
          headers: {
            Authorization: 'Bearer ' + this.access_token,
            'Content-Type': 'application/json',
          },
        });
        this.trainer = data.all_data || {};
      } catch (error) {
        console.log(error.response || error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.bdr-rad {
  border-radius: 12px;
}

.bdr-rad2 {
  border-radius: 15px;
}

.decoration {
  text-decoration: none;
  color: white !important;
}

.font1 {
  font-size: 13px !important;
}

.manage-boder {
  border-bottom: 2px solid #007bff;
  border-top: 2px solid #007bff;
  padding-bottom: 10px !important;
  padding-top: 10px !important;
}
</style>
